var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"clipRule":"evenodd","d":"M2.272 2.59h11.455c.703 0 1.273.57 1.273 1.274v8.272c0 .703-.57 1.273-1.272 1.273H2.272c-.702 0-1.272-.57-1.272-1.273V3.864c0-.703.57-1.273 1.272-1.273z","stroke":"currentColor","strokeWidth":"1.944","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1.5 4l5.566 3.633a1.577 1.577 0 001.833.001L14.5 4","stroke":"currentColor","strokeWidth":"1.971","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Email.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = Email;

Email.default = Email;
